<script>
  import { emitter } from '@/main.js';
  export default {
    name: 'PDPinventory',
    data() {
      return {
        quantityAvailable: '',
        inventoryCountdown: '',
        showInventoryMessage: '',
        showAlways: '',
        instock: '',
        notavail: '',
        productType: '',
        show: false
      };
    },
    mounted() {
      this.inventoryCountdown = this.$el.parentElement.getAttribute('data-inventory-countdown');
      this.showInventoryMessage = this.$el.parentElement.getAttribute('data-show-inventory-message');
      this.showAlways = this.$el.parentElement.getAttribute('data-show-style');
      emitter.on('updateAddButton', e => {
        this.quantityAvailable = e.quantityAvailable;
        this.instock = e.instock;
        this.notavail = e.notavail;
        this.productType = e.productType;
        this.show = this.shouldShowWidget(e.quantityAvailable);
      });
    },
    methods: {
      shouldShowWidget(amt) {
        let show = false;
        if (this.showAlways === 'true' && this.showInventoryMessage === 'true') {
          show = true;
        }

        if (parseInt(amt) < parseInt(this.inventoryCountdown)) {
          show = true;
        }

        if (this.showInventoryMessage === 'false') {
          show = false;
        }

        if (this.productType === 'Gift Card') {
          show = false;
        }

        return show;
      }
    }
  };
</script>

<template>
  <p class="variant__countdown" v-if="show">
    <span v-if="quantityAvailable >= inventoryCountdown" class="gt-p__small">Item is in stock</span>
    <span v-if="quantityAvailable < inventoryCountdown" class="gt-p__small">Only <span v-html="quantityAvailable"></span> left in stock</span>
    <span v-if="instock === false && notavail === false" class="gt-p__small">Item is out of stock</span>
    <span v-if="notavail === true" class="gt-p__small">Item is unavailable</span>
  </p>
</template>

<style lang="scss">
  .PDPinventory {
    height: 20px;

    .variant__countdown {
      padding: 0;
      margin: 0;
    }
  }
</style>
